import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=d741fff6&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=d741fff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d741fff6",
  null
  
)

export default component.exports